import React, { useState, useEffect } from 'react'

import HoverTooltip from '../../../../../../components/HoverTooltip'
import MoneyInput from '../../../../../../components/form/MoneyInput'
import CurrencySelector from '../../../../../../components/currency/CurrencySelector'
import CurrencyExchangeRateInput from '../../../../../../components/currency/CurrencyExchangeRateInput'

import Section from '../../../../../../components/Section'
import {
    Contract,
    ContractPerformance,
    LongTermContractVolumes,
    ContractConfirmingDoc,
    Suppliers,
    ContractSupplier,
    CountryList,
} from '../../../types'

import { CurrencyList } from '../../../../Plans/Positions/Edit/types'

import {
    purchaseTypeInfo,
    purchaseInfo,
    planInfo,
    ContractSuppliersInfoError,
    RegionRf,
} from '../types'

import Checkbox from '../../../../../../components/form/Checkbox'
import ContractConfirmingDocsTable from './ContractTable/ContractConfirmingDocsTable'

import ContractSuppliersTable from './ContractTable/ContractSuppliersTable'

type Props = {
    theme: string
    contractAction: boolean
    contractGuid: string | undefined
    contract: Contract
    errors?: ContractSuppliersInfoError
    contractSuppliers: ContractSupplier[]
    onUpdateSupplier: (guid: string, patch: Partial<ContractSupplier>) => void
    onDeleteSupplier: (rowKey: string) => void
    onAddSupplier: (supplier: ContractSupplier) => void
    oksmList: CountryList[]
    regionRfList: RegionRf[]
}

const ContractSuppliers: React.FC<Props> = (props) => {
    return (
        <Section title="Сведения о поставщиках (исполнителях, подрядчиках)">
            {/* <fieldset disabled={props.contractAction}> */}
            <div className="flex flex-col w-full gap-3 items-start justify-start ">
                <ContractSuppliersTable
                    theme={props.theme}
                    contractAction={props.contractAction}
                    contractGuid={props.contractGuid}
                    contract={props.contract}
                    errors={props.errors}
                    onPatch={props.onUpdateSupplier}
                    onDeleteSupplier={props.onDeleteSupplier}
                    onAddSupplier={props.onAddSupplier}
                    contractSuppliers={props.contractSuppliers}
                    oksmList={props.oksmList}
                    regionRfList={props.regionRfList}
                />
            </div>
            {/* </fieldset> */}
        </Section>
    )
}

export default ContractSuppliers
